function rewindGeoJsonRings(rings, outer) {
  if (rings.length === 0) return;

  rewindGeoJsonRing(rings[0], outer);
  for (let i = 1; i < rings.length; i++) {
    rewindGeoJsonRing(rings[i], !outer);
  }
}

function rewindGeoJsonRing(ring, dir) {
  let area = 0,
    err = 0;
  for (let i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
    let k = (ring[i][0] - ring[j][0]) * (ring[j][1] + ring[i][1]);
    let m = area + k;
    err += Math.abs(area) >= Math.abs(k) ? area - m + k : k - m + area;
    area = m;
  }
  if (area + err >= 0 !== !!dir) ring.reverse();
}

export function rewindGeoJson(geojson, outer) {
  let type = geojson && geojson.type,
    i;

  if (type === 'FeatureCollection') {
    for (i = 0; i < geojson.features.length; i++) rewindGeoJson(geojson.features[i], outer);
  } else if (type === 'GeometryCollection') {
    for (i = 0; i < geojson.geometries.length; i++) rewindGeoJson(geojson.geometries[i], outer);
  } else if (type === 'Feature') {
    rewindGeoJson(geojson.geometry, outer);
  } else if (type === 'Polygon') {
    rewindGeoJsonRings(geojson.coordinates, outer);
  } else if (type === 'MultiPolygon') {
    for (i = 0; i < geojson.coordinates.length; i++) rewindGeoJsonRings(geojson.coordinates[i], outer);
  }

  return geojson;
}

export function ensureClosedPolygonRing(coordinates) {
  if (coordinates.length === 0) return coordinates;

  // Ensure the first and last positions are equivalent
  const firstPos = coordinates[0];
  const lastPos = coordinates[coordinates.length - 1];
  if (firstPos.length !== lastPos.length || !firstPos.every((val, index) => val === lastPos[index])) {
    coordinates.push([...firstPos]);
  }

  return coordinates;
}
